import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LineHeightByComponent } from '@df/ui/common/line-height-by.component';
import { Loader1Component } from '../../loader/loader-1.component';
import { AbstractButtonComponent } from '../abstract-button.component';

export const buttonStylesOptions: { key: TButtonStyles; title: string }[] = [
    { key: 'button', title: 'Button Primary' },
    { key: 'button-1', title: 'Button Secondary' },
    { key: 'button-2', title: 'Button Tertiary' },
    { key: 'text-button', title: 'Text Button' }
];

export type TButtonStyles = 'button' | 'button-1' | 'button-2' | 'text-button';

@Component({
    imports: [LineHeightByComponent, Loader1Component],
    selector: 'button[buttonStyle], a[buttonStyle], span[buttonStyle], label[buttonStyle]',
    templateUrl: './button-style.html',
    styleUrl: './button-style.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonStyleComponent extends AbstractButtonComponent {
    @Input()
    buttonStyle: TButtonStyles | undefined | '' = 'button';

    protected variantInputName = 'buttonStyle';
}
